'use client';

import React from 'react';
import { useRemoveScrollLock } from '@/shared/hooks/dom/useRemoveScrollLock';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shared/ui/select';
interface Props {
  value: string;
  changeValue: (value: string) => void;
  placeholder: string;
  options: {
    value: string | number;
    label: string;
  }[];
}

// @todo: отдельный виджет для фильтров везде по сайту
export const SkillsSelect: React.FC<Props> = ({
  value,
  changeValue,
  options,
  placeholder
}) => {
  useRemoveScrollLock(true);
  return <Select value={value} onValueChange={changeValue} data-sentry-element="Select" data-sentry-component="SkillsSelect" data-sentry-source-file="SkillsSelect.tsx">
      <SelectTrigger className="w-full" data-sentry-element="SelectTrigger" data-sentry-source-file="SkillsSelect.tsx">
        <SelectValue active={value !== ''} placeholder={placeholder} data-sentry-element="SelectValue" data-sentry-source-file="SkillsSelect.tsx" />
      </SelectTrigger>
      <SelectContent data-sentry-element="SelectContent" data-sentry-source-file="SkillsSelect.tsx">
        {options.map(option => {
        return <SelectItem key={option.value} value={option.value.toString()}>
              {option.label}
            </SelectItem>;
      })}
      </SelectContent>
    </Select>;
};